import cx from "classnames";
import React from "react";
import { Button as BaseButton } from "reactstrap";
import classes from "./styles.module.scss";
import { Props } from "./types";

const Button: React.FC<Props> = (Props) => {
  const {
    variant = "fill",
    rightIcon,
    leftIcon,
    buttonText,
    buttonClassName = "",
    loading = false,
    disabled = false,
    buttonColor = "primary",
    size = "md",
    dark,
    weight,
    fullWidth,
    radius,
    gapSize,
    flex,
    isGhost,
    textSize,
    paddingSize,
    linkHasLoading,
    ...rest
  } = Props;

  const hasIcons = !!rightIcon || !!leftIcon || loading;
  const linkIsLoading = linkHasLoading && loading;
  const renderLeftIcon = () => {
    if (!leftIcon) return;
    return (
      <span className={cx("btn-inner--icon", classes.leftIconStyling)}>
        {leftIcon}
      </span>
    );
  };

  const renderRightIcon = () => {
    if (!rightIcon) return;
    return (
      <span className={cx("btn-inner--icon", classes.rightIconStyling)}>
        {rightIcon}
      </span>
    );
  };

  const renderButton = () => {
    if (!buttonText) return;
    return (
      <span
        className={cx({ "btn-inner--text": hasIcons }, classes.spanWrapper)}
      >
        {buttonText}
        {loading && (
          <span className="btn-inner--icon px-1">
            <i className="fa fa-circle-o-notch fa-spin" />
          </span>
        )}
      </span>
    );
  };
  if (variant === "link") {
    return (
      <span
        className={cx(
          classes.link,
          classes[`${buttonColor}-link`],
          {
            [classes.disabled]: disabled,
          },
          classes[`fontWeight_${weight}`],
          classes[`text_size_${textSize}`]
        )}
        {...rest}
        onClick={disabled ? () => {} : rest.onClick}
      >
        {!linkIsLoading && renderLeftIcon()}
        {buttonText}
        {!linkIsLoading && renderRightIcon()}
        {linkIsLoading && (
          <span className="btn-inner--icon px-1">
            <i className="fa fa-circle-o-notch fa-spin" />
          </span>
        )}
      </span>
    );
  }

  return (
    <BaseButton
      className={cx(
        classes.buttonStyling,
        {
          [buttonClassName]: buttonClassName,
          "btn-icon": hasIcons,
          [classes.disabled]: disabled,
          [classes.noButtonText]: !buttonText,
          [classes.dark]: !!dark,
          [classes.fullWidth]: !!fullWidth,
          [classes.flex]: flex,
          [classes.isGhost]: isGhost,
        },
        classes[`${buttonColor}-${variant}`],
        classes[`fontWeight_${weight}`],
        classes[size],
        classes[`radius_${radius}`],
        classes[`gap_${gapSize}`],
        classes[`text_size_${textSize}`],
        classes[`padding_size_${paddingSize}`]
      )}
      size={size}
      disabled={disabled || loading}
      {...rest}
    >
      {renderLeftIcon()}
      {renderButton()}
      {renderRightIcon()}
    </BaseButton>
  );
};

export default Button;
